import React from 'react';

import './ClaimAsset.css';

function ClaimAsset(props) {

    const [ready, setReady] = React.useState(false);
    const [claimed, setClaimed] = React.useState(false);
    const [txHash, setTxHash] = React.useState('');
    const [confirmations, setConfirmations] = React.useState(0);
    const [proofs, setProofs] = React.useState(0);

    const empty = () => {
        alert('bad');
    }

    const checkTx = () => {
        if (txHash.slice(0,2) === '0x' && txHash.length === 66) {
            setReady(true);
	} else {
            alert('bad');
	}
    }

    const checkValidity = (event) => {
        let value = event.target.value;
        console.log(value, txHash, txHash.length, txHash.slice(0,2));
        if (txHash.slice(0,2) !== '0x' && value !== '0x') {
            if (value.slice(0,2) === '0x') {
	        value = value.replace('0x','');
	    }
            value = '0x' + value;
	} else if (value === '0x') {
	    value = '';
	}
        setTxHash(value);
    }

    const goBack = () => {
        setConfirmations(0);
        setProofs(0);
        setReady(false);
        setTxHash('');
        setClaimed(false);
    }

    React.useEffect(() => {
        let timeout;
        let otherTimeout;
        if (ready && confirmations < 15) {
	    timeout = setInterval(() => {
	        setConfirmations(confirmations + 1);
	    }, 500);
            
	}

        if (confirmations >= 15 && proofs < 23) {
	    otherTimeout = setInterval(() => {
	        setProofs(proofs + 1);
	    }, 200);
	}

        if (confirmations >= 15 && proofs >= 23) {
	    setClaimed(true);
	}
        
        return () => {
            clearInterval(timeout);
            clearInterval(otherTimeout);
	}
    }, [ready, confirmations, proofs]);

    return(
        <div className="ghost-claim-asset-container">
        
            <div className="ghost-claim-asset-text-box">
	        <input value={txHash} onChange={checkValidity} type="text" placeholder="tx hash (0x123456...)"></input>
	    </div>

	    {!ready ?
                <div className="ghost-claim-asset-prefix">Input your transaction hash.</div>
                :
                !claimed ?
                    <div className="ghost-claim-asset-state">
                        <div style={{ opacity: parseFloat(confirmations/15) }} className="ghost-claim-asset-state-tx">
	                    <div className="ghost-claim-asset-state-tx-stat">{confirmations} / 15</div>
	                    <div className="ghost-claim-asset-state-tx-name">confirmations</div>
	                </div>
                        <div style={{ opacity: parseFloat(proofs/23) }} className="ghost-claim-asset-proofs-tx">
	                    <div className="ghost-claim-asset-proofs-tx-stat">{proofs} / 23</div>
	                    <div className="ghost-claim-asset-proofs-tx-name">blind proofs</div>
	                </div>
	            </div>
		:
		<div className="ghost-claim-asset-prefix">Transaction passed Check your GHOST balance.</div>
	    }

	    <div style={!claimed ? { justifyContent: 'space-between' } : { justifyContent: 'center' }} className="ghost-claim-asset-buttons">
	        <div onClick={() => !ready ? props.setStep(props.step-1) : goBack()} className="ghost-claim-asset-buttons-button">{ready ? "Back to Check" : "Previous Step"}</div>
	    {!claimed ?
                <div  onClick={() => !ready ? checkTx() : empty()} className={ ready ? "ghost-claim-asset-buttons-button" : "ghost-claim-asset-buttons-button-inactive"}>{ready ? "Claim" : "Check"}</div>
                :
                <React.Fragment></React.Fragment>
	    }
	    </div>
	    
	</div>
    )
}

export default ClaimAsset;
